var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cropper-upload" },
    [
      _c("div", { staticClass: "cropper-wrap" }, [
        _vm.imageData
          ? _c("img", {
              ref: "image",
              staticClass: "image",
              attrs: { src: _vm.imageData }
            })
          : _c("p", { staticClass: "no-data-tips" }, [
              _vm._v("请选择图片,只能上传jpg/png文件；不支持png24/gif格式。")
            ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "control-wrap" },
        [
          _c(
            "el-upload",
            {
              staticClass: "fe-upload",
              attrs: {
                action: "",
                name: "fe_upload",
                "http-request": _vm.selectFileHandler,
                "show-file-list": false
              }
            },
            [
              _c("el-button", { attrs: { size: "mini", type: "primary" } }, [
                _vm._v("选择图片")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.imageData
            ? _c(
                "el-button-group",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", title: "逆时针旋转" },
                      on: {
                        click: function($event) {
                          return _vm.rotateImage(-90)
                        }
                      }
                    },
                    [_vm._v("-90°")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", title: "顺时针旋转" },
                      on: {
                        click: function($event) {
                          return _vm.rotateImage(90)
                        }
                      }
                    },
                    [_vm._v("+90°")]
                  ),
                  _vm._v(" "),
                  _c("el-button", {
                    attrs: {
                      size: "mini",
                      icon: "el-icon-zoom-in",
                      title: "缩小图片"
                    },
                    on: {
                      click: function($event) {
                        return _vm.zoomImage(-0.1)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("el-button", {
                    attrs: {
                      size: "mini",
                      icon: "el-icon-zoom-out",
                      title: "放大图片"
                    },
                    on: {
                      click: function($event) {
                        return _vm.zoomImage(0.1)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", title: "裁剪窗放大到100%" },
                      on: {
                        click: function($event) {
                          return _vm.cropperBoxChange(1000)
                        }
                      }
                    },
                    [_vm._v("100%")]
                  ),
                  _vm._v(" "),
                  _c("el-button", {
                    attrs: {
                      size: "mini",
                      icon: "el-icon-refresh",
                      title: "重置"
                    },
                    on: { click: _vm.resetCropper }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", title: "预览裁剪图片" },
                      on: { click: _vm.priviewCropper }
                    },
                    [_vm._v("预览")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.imageData
            ? _c("el-button", {
                staticClass: "upload-btn",
                attrs: {
                  type: "primary",
                  size: "mini",
                  icon: "el-icon-upload",
                  title: "上传裁剪后的图片"
                },
                on: { click: _vm.uploadHandler }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "预览", width: "500px", visible: _vm.previewShow },
          on: {
            "update:visible": function($event) {
              _vm.previewShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "preview-wrap" }, [
            _c("img", {
              staticClass: "preview-dom",
              attrs: { src: _vm.previewData }
            })
          ])
        ]
      ),
      _vm._v(" "),
      !_vm.supportFileReader
        ? _c("p", { staticClass: "no-support-filereader" }, [
            _vm._v("抱歉，您的浏览器不支持该功能。"),
            _c("br"),
            _vm._v("建议使用最新版本的chrome浏览器。")
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39ec660e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39ec660e","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cropperUpload.vue
// module id = 1216
// module chunks = 7